<template>
  <div class="v3-widget v3-panel" v-testid="testid">
    <div class="v3-panel-head">
      <h3 v-testid="testid + '-title'">{{ title }}</h3>
      <span v-if="ac.count.value" class="v3-count">{{ ac.count.value }}</span>
    </div>

    <V3Skeleton v-if="ac.isLoading.value && !ac.count.value" shape="list" :heading="false" />
    <div v-else-if="!ac.count.value" class="v3-task-empty" v-testid="testid + '-empty'">No recent activity.</div>

    <template v-else>
      <button v-if="ac.showAll.value" class="v3-viewall" type="button" v-testid="testid + '-show-less'" @click="ac.showAll.value = false">
        Show less
      </button>

      <div class="v3-act-list">
      <div
        v-for="r in ac.shownRows.value"
        :key="r.document_activity_id"
        class="v3-act"
        role="button"
        tabindex="0"
        v-testid="testid + '-row-' + r.document_activity_id"
        @click="open(r)"
      >
        <span class="v3-act-ic" :class="{ 'is-good': ac.tone(r) === 'good', 'is-warn': ac.tone(r) === 'warn' }"><span class="ms">{{ ac.icon(r) }}</span></span>
        <span class="v3-act-text"><strong>{{ ac.who(r) }}</strong> {{ ac.action(r) }} <span class="t">{{ ac.target(r) }}</span></span>
        <span class="v3-act-when">{{ ac.whenText(r) }}</span>
      </div>
      </div>

      <button v-if="ac.hasMore.value" class="v3-viewall" type="button" v-testid="testid + '-view-all'" @click="ac.showAll.value = !ac.showAll.value">
        {{ ac.showAll.value ? 'Show less' : 'Show all (' + ac.count.value + ')' }}
      </button>
    </template>
  </div>
</template>

<script>
import axios from "axios";
import { activity } from "@rm-ui/homepage/activity";
import V3Skeleton from "./cLandingV3Skeleton";

// New-portal (v3) Activity — thin Vue 2 presentation over the shared `activity`
// composable (@rm-ui/homepage/activity), backed by POST Report/activity. A
// recent event stream with event-type icon/tone. Sibling: rm-portal-beta
// ActivityWidget.vue.
export default {
  name: "cLandingV3Activity",
  components: { V3Skeleton },
  props: {
    definition: { type: Object, default: () => ({}) },
    editMode: { type: Boolean, default: false },
    qaActions: { type: Array, default: () => [] },
  },
  setup(props) {
    const ac = activity({
      http: axios,
      getLimit: () => props.definition.limit || 8,
      getDays: () => props.definition.days || 30,
      getScope: () => props.definition.scope || "all",
    });
    return { ac };
  },
  computed: {
    testid() {
      return this.definition.controlType || "v3Activity";
    },
    title() {
      return this.definition.title || "Recent activity";
    },
  },
  methods: {
    open(r) {
      if (this.editMode) return;
      const reference = r.reference || r.system_number;
      if (reference) this.$emit("openDocument", { system_number: reference, reference });
    },
  },
};
</script>

<style lang="scss" src="./v3Widgets.scss"></style>
